/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultFromJSON, FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultToJSON, } from './FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResult';
/**
 * Check if a given object implements the FxIdWebFeaturesProfileFetchFxIdGameConnectionResponse interface.
 */
export function instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseFromJSON(json) {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Result': json['Result'] == null ? undefined : FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultFromJSON(json['Result']),
    };
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseToJSON(json) {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Result': FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultToJSON(value['Result']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileFetchFxIdGameConnectionResponse.js.map